import createIcon from '../../createIcon';

/**
 * @component @name Equalizer
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMjBIMTRWNEgxMFYyMFpNNCAyMEg4VjEySDRWMjBaTTE2IDlWMjBIMjBWOUgxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Equalizer = createIcon('Equalizer', [
  ['path', { d: 'M10 20H14V4H10V20ZM4 20H8V12H4V20ZM16 9V20H20V9H16Z', key: '1m74hg' }],
]);

export default Equalizer;
